"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icon_1 = require("../../../elements/icon/icon");
var icon_type_1 = require("../../../elements/icon/icon-type");
var tooltip_1 = require("../../tooltip/tooltip");
var tooltip_type_1 = require("../../tooltip/tooltip-type");
var section_header_style_1 = require("./section-header-style");
function SectionHeader(props) {
    var title = props.title, description = props.description, infoText = props.infoText;
    return ((0, jsx_runtime_1.jsxs)(section_header_style_1.StyledSectionHeader, { children: [(0, jsx_runtime_1.jsxs)(section_header_style_1.StyledSectionHeaderTitle, { children: [title, ' ', infoText ? ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { place: tooltip_type_1.TooltipPlace.TOP, id: "section-header-id", content: infoText, mode: tooltip_type_1.TooltipMode.DARK, children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.INFO_FILLED, fill: "#798686" }) }) })) : null] }), (0, jsx_runtime_1.jsx)(section_header_style_1.StyledSectionHeaderDescription, { children: description })] }));
}
exports.SectionHeader = SectionHeader;
